const browserChecker = () => ({
    initialise() {
        const isDateSupported = function () {
            const input = document.createElement('input');
            const value = 'test-value';

            input.setAttribute('type', 'date');
            input.setAttribute('value', value);

            return input.value !== value;
        };

        const dateElements = document.querySelectorAll('[data-date-field]');

        for (let i = 0; i < dateElements.length; i += 1) {
            if (!isDateSupported()) {
                if (dateElements[i].dataset.dateField === 'other')
                    dateElements[i].parentNode.removeChild(dateElements[i]);
            } else if (dateElements[i].dataset.dateField === 'safari')
                dateElements[i].parentNode.removeChild(dateElements[i]);
        }
    }
});

export default function browser() {
    window.browserChecker = browserChecker;
}



// WEBPACK FOOTER //
// ./resources/js/frontend/components/browserChecker.js